// src/components/Header.js
import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Header.css';
import logo from '../assets/logo.png';

const Header = () => (
  <nav className="navbar navbar-expand-lg navbar-light bg-light">
    <div className="container">
      <Link className="navbar-brand" to="/">
        <img src={logo} alt="Laboratorio de Análisis Clínicos" className="logo" />
      </Link>

      {/* BS5: data-bs-toggle / data-bs-target */}
      <button
        className="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon"></span>
      </button>

      <div className="collapse navbar-collapse" id="navbarNav">
        <ul className="navbar-nav me-auto">
          <li className="nav-item"><Link className="nav-link" to="/">Inicio</Link></li>
          <li className="nav-item">
            <a className="nav-link" href="https://cap.pasteur.com.mx/Comun.aspx?c=1" target="_blank" rel="noopener noreferrer">Resultados</a>
          </li>
          <li className="nav-item"><Link className="nav-link" to="/ubicacion">Ubicación</Link></li>
          <li className="nav-item"><Link className="nav-link" to="/certificados">Certificados</Link></li>
          <li className="nav-item"><Link className="nav-link" to="/contacto">Contacto</Link></li>
          <li className="nav-item"><Link className="nav-link" to="/nosotros">Quienes somos</Link></li>
          <li className="nav-item"><Link className="nav-link" to="/aviso">Aviso de Privacidad</Link></li>
          <li className="nav-item"><Link className="nav-link" to="/estudios">Estudios</Link></li>
        </ul>
      </div>
    </div>
  </nav>
);

export default Header;
